// extracted by mini-css-extract-plugin
export var block = "search-module--block--1jiAr";
export var formTypeSearch = "search-module--formTypeSearch--3FAHb";
export var formSearch = "search-module--formSearch--3Zn5J";
export var formActions = "search-module--formActions--1W7aK";
export var button = "search-module--button--3qPey";
export var formSubmit = "search-module--formSubmit--2q-x0";
export var iconWrap = "search-module--iconWrap--1uaUP";
export var searchLink = "search-module--searchLink--3MMzC";